import { styled } from "@mui/material/styles";

import {
  borderColor,
  inkColor,
  paperColor,
  strongBorderColor,
} from "~/styles/redesignColors";

export const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: 8,
  padding: "10px 12px",
  border: `1px solid ${borderColor(theme)}`,
  borderRadius: 5,
}));

export const Title = styled("span")(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  lineHeight: "normal",
  color: inkColor(theme),
}));

export const Form = styled("form")({
  display: "flex",
  gap: 6,
});

export const Email = styled("input")(({ theme }) => ({
  flex: "1 1 auto",
  minWidth: 0,
  height: 32,
  boxSizing: "border-box",
  padding: "0 12px",
  border: `1px solid ${strongBorderColor(theme)}`,
  borderRadius: 999,
  outline: "none",
  backgroundColor: paperColor(theme),
  fontFamily: "inherit",
  fontSize: 12,
  color: inkColor(theme),

  "&:focus-visible": {
    borderColor: inkColor(theme),
  },

  "&[aria-invalid='true']": {
    borderColor: theme.palette.error.main,
  },
}));

export const FieldError = styled("span")(({ theme }) => ({
  fontSize: 11,
  lineHeight: 1.45,
  color: theme.palette.error.main,
}));

export const Subscribed = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: "normal",
  color: theme.palette.success.dark,

  "& svg": {
    fontSize: 16,
  },
}));
